/**
 * bar tab and pay at table sub feature combined
 */
function barTabAndPatFeature(integrationSettingsService, integrationConstant,
                             integrationViewService, appConfig) {
    const vm = this;

    const manageDisplay = () => {
        const parentComponentRules = vm.mapVisibleFeature;
        const options = {
            parentData: vm.parentData || null,
            isUseMerchantSettings: vm.data.isUseMerchantSettings,
            permission: {
                isAccountManager: appConfig.isMCAdmin
            },
            parentComponentRules
        };
        // api visible parent and local events decides what's to display
        vm.visible = integrationViewService.getBtAndPatDisplay(options, vm.location);
    };

    vm.updateBtAndPatCombined = () => {
        vm.onDataUpdate({updatedData: vm.data});
    };

    vm.updateBtAndPatAutoBilling = () => {
        vm.data.autoBillingContactDetails = null;
        vm.data.upfrontCardValidation = vm.data.autoBilling;
        vm.updateBtAndPatCombined();
    };

    vm.$onInit = () => {
        vm.RADIO_YES = integrationConstant.VIEW_SETTINGS.RADIO_YES;
        vm.RADIO_NO = integrationConstant.VIEW_SETTINGS.RADIO_NO;

        vm.data = integrationSettingsService.merge({}, vm.integrationData);
        manageDisplay();
    };
    vm.$onChanges = (changesObj) => {
        if (changesObj.integrationData) {
            // Changes in the integrationData on the parent needs to be update
            vm.data = integrationSettingsService.merge({}, changesObj.integrationData.currentValue);
            manageDisplay();
        }
    };
}
angular.module('qkr.integration.settings')
    .component('barTabAndPatFeature', {
        template: require('./bt-and-pat.html'),
        bindings: {
            integrationData: '<',
            integrationForm: '<',
            mapVisibleFeature: '<',
            location: '<',
            onDataUpdate: '&'
        },
        controller: barTabAndPatFeature,
        controllerAs: 'vm'
    });





// WEBPACK FOOTER //
// ./src/integration-settings/components/children-components/types/pos-feature/pos-sub-feature/bt.and.pat.component.js